import { render, staticRenderFns } from "./EditarAditivoConvenio.vue?vue&type=template&id=35aa400c"
import script from "./EditarAditivoConvenio.vue?vue&type=script&lang=ts"
export * from "./EditarAditivoConvenio.vue?vue&type=script&lang=ts"
import style0 from "./EditarAditivoConvenio.vue?vue&type=style&index=0&id=35aa400c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports